<template>
  <div class="lmnr1 container">

    <NavList :init-nav-id="navId" />

    <div class="fr lmnr2 col-md-9">
      <h2>{{article.title}}</h2>
      <p class="jz19"><span class="fbsj119">更新时间:{{handleDate('day',article.published_at)}}</span>
      </p>
      <div class="lmnr3 pt0" style="padding: 0 2rem;"  v-html="article.content"></div>
    </div>

    <div class="clear"></div>
  </div>
</template>
<script>
import NavList from "@/components/NavList"
import {getCertProducts} from "@/api/home"
import {getFormatDate} from "@/utils"
export default {
  components:{NavList},
  data() {
    return {
      aid:this.$route.params.aid,
      article:{},
      navId:0,
    }
  },
  created() {
    this.getData()
  },
  methods:{
    getData(){
      const temp = {id:this.aid}
      getCertProducts(temp).then((response)=>{
        this.article = response[0]
        // this.navId = response[0]['nav']['id']
      })
    },
    handleDate(n){
      return getFormatDate(n)
    }
  }
}
</script>